import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

export default ({closeModalDeleteUser, handleDeleteUser, user: { username }}) => {

    const actions = [
        <FlatButton label="Cancel" primary={true} onClick={closeModalDeleteUser} />,
        <FlatButton label="Delete" primary={true} onClick={handleDeleteUser} type="submit" />,
    ];

    return (
        <div style={{margin: '5px'}}>
            <Dialog actions={actions} modal={false} open={true} onRequestClose={closeModalDeleteUser}>
                Do you want to delete the user: {username}?
                Have you considered disabling the user instead?
            </Dialog>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/dialog/ConfirmDialog.js